import React, {useRef} from 'react';
import _ from 'lodash';
import localeText from '@locale';
import {useSize} from 'ahooks';
import Header from '~/components/Header';
import Banner from '~/components/Banner';
import Content from './Content';
import NotFound from '~/components/404';
import {setLanguage, getTutorialConfig} from '~/utils/tools';
import BannerBg from '~/assets/images/tutorial/banner/banner_bg_tutorials.png';
import './index.less';

const Tutorial = ({history, match}) => {
  const {
    params: {locale, version}
  } = match;
  const pageRef = useRef(null);
  const pageSize = useSize(pageRef);
  setLanguage(locale);
  const tutorialConfig = getTutorialConfig(locale);

  const versionKeys = Object.keys(tutorialConfig).sort((p, n) => tutorialConfig[p].order - tutorialConfig[n].order);
  if (_.indexOf(versionKeys, version) === -1) {
    return <NotFound />;
  }

  return (
    <div className='tutorial' ref={pageRef}>
      <Header
        locale={locale}
        version={version}
        pageSize={pageSize}
        isTutorial
        configData={tutorialConfig?.[version]?.header || []}
        versionKeys={versionKeys}
        history={history}
        isLanding
      />
      <Banner
        bannerBg={BannerBg}
        title={localeText('COMMON.TXT_TUTORIAL_TITLE')}
        description={localeText('COMMON.TXT_TUTORIAL_DESCRIPTION')}
      />
      <Content configData={tutorialConfig?.[version]?.content || []} />
      <div className='copy-right'>{localeText('COMMON.TXT_COPY_RIGHT', new Date().getFullYear())}</div>
      {/* <div>
        <i className='dpl20_up_s' />
        <i className='dpl20_down_s' />
        <i className='dpl20_left_s' />
        <i className='dpl20_right_s' />
        <i className='dpl20_up_down_s' />
        <i className='dpl20_wrong_s' />
        <i className='dpl20_double_left_s' />
        <i className='dpl20_double_right_s' />
        <i className='dpl20_plus_square_s' />
        <i className='dpl20_minus_square_s' />
        <i className='dpl20_back_s' />
        <i className='dpl20_configure_s' />
        <i className='dpl20_time_circle_s' />
        <i className='dpl20_plus_s' />
        <i className='dpl20_minus_s' />
        <i className='dpl20_caret_up_s' />
        <i className='dpl20_caret_down_s' />
        <i className='dpl20_caret_left_s' />
        <i className='dpl20_caret_right_s' />
        <i className='dpl20_filter_s' />
        <i className='dpl20_shortcut' />
        <i className='dpl20_application' />
        <i className='dpl20_AD' />
        <i className='dpl20_menu_group' />
        <i className='dpl20_alarm_box' />
        <i className='dpl20_alarm_portal' />
        <i className='dpl20_mute' />
        <i className='dpl20_no_alarm_box' />
        <i className='dpl20_sound' />
        <i className='dpl20_plus' />
        <i className='dpl20_minus' />
        <i className='dpl20_wrong' />
        <i className='dpl20_check' />
        <i className='dpl20_up' />
        <i className='dpl20_down' />
        <i className='dpl20_right' />
        <i className='dpl20_left' />
        <i className='dpl20_plus_circle_so' />
        <i className='dpl20_minus_circle_so' />
        <i className='dpl20_wrong_circle_so' />
        <i className='dpl20_right_circle_so' />
        <i className='dpl20_exclamation_circle_so' />
        <i className='dpl20_info_circle_so' />
        <i className='dpl20_quwstion_circle_so' />
        <i className='dpl20_plus_circle' />
        <i className='dpl20_minus_circle' />
        <i className='dpl20_wrong_circle' />
        <i className='dpl20_right_circle' />
        <i className='dpl20_exclamation_circle' />
        <i className='dpl20_info_circle' />
        <i className='dpl20_quwstion_circle' />
        <i className='dpl20_menu' />
        <i className='dpl20_menu_fold' />
        <i className='dpl20_menu_unfold' />
        <i className='dpl20_ascending' />
        <i className='dpl20_descending' />
        <i className='dpl20_upload' />
        <i className='dpl20_download' />
        <i className='dpl20_logout' />
        <i className='dpl20_refresh' />
        <i className='dpl20_reset' />
        <i className='dpl20_swap' />
        <i className='dpl20_delete' />
        <i className='dpl20_editor' />
        <i className='dpl20_authorization' />
        <i className='dpl20_search' />
        <i className='dpl20_bug' />
        <i className='dpl20_internationalization' />
        <i className='dpl20_message' />
        <i className='dpl20_remove' />
        <i className='dpl20_link' />
        <i className='dpl20_rename' />
        <i className='dpl20_date' />
        <i className='dpl20_view' />
        <i className='dpl20_alarm' />
        <i className='dpl20_pin' />
        <i className='dpl20_lock' />
        <i className='dpl20_user' />
        <i className='dpl20_user_group' />
        <i className='dpl20_administrator' />
        <i className='dpl20_package' />
        <i className='dpl20_structure' />
        <i className='dpl20_visible' />
        <i className='dpl20_invisible' />
        <i className='dpl20_home' />
        <i className='dpl20_position' />
        <i className='dpl20_setting' />
        <i className='dpl20_key' />
        <i className='dpl20_ellipsis' />
        <i className='dpl20_service' />
        <i className='dpl20_network' />
        <i className='dpl20_no_network' />
        <i className='dpl20_select' />
        <i className='dpl20_tool' />
        <i className='dpl20_layer' />
        <i className='dpl20_location' />
        <i className='dpl20_share' />
        <i className='dpl20_scan' />
        <i className='dpl20_filter' />
        <i className='dpl20_save' />
        <i className='dpl20_loading' />
        <i className='dpl20_history' />
        <i className='dpl20_configure' />
        <i className='dpl20_document' />
        <i className='dpl20_wrong_circle_o_l' />
        <i className='dpl20_right_circle_o_l' />
        <i className='dpl20_info_circle_o_l' />
        <i className='dpl20_exclamation_circle_o_l' />
        <i className='dpl20_quwstion_circle_o_l' />
      </div> */}
    </div>
  );
};

export default Tutorial;
